import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import'rxjs/add/operator/startWith';
import'rxjs/add/operator/map';
export class User {
/**
 * @param {?} name
 */
constructor(public name: string) { }
}

function User_tsickle_Closure_declarations() {
/** @type {?} */
User.prototype.name;
}

/**
 * \@title Display value autocomplete
 */
export class AutocompleteDisplayExample {

  myControl = new FormControl();

  options = [
    new User('Mary'),
    new User('Shelley'),
    new User('Igor')
  ];

  filteredOptions: Observable<User[]>;
/**
 * @return {?}
 */
ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges
        .startWith(null)
        .map(user => user && typeof user === 'object' ? user.name : user)
        .map(name => name ? this.filter(name) : this.options.slice());
  }
/**
 * @param {?} name
 * @return {?}
 */
filter(name: string): User[] {
    return this.options.filter(option =>
      option.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
/**
 * @param {?} user
 * @return {?}
 */
displayFn(user: User): string {
    return user ? user.name : user;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'autocomplete-display-example',
  templateUrl: 'autocomplete-display-example.html',
  styleUrls: ['autocomplete-display-example.css']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AutocompleteDisplayExample_tsickle_Closure_declarations() {
/** @type {?} */
AutocompleteDisplayExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutocompleteDisplayExample.ctorParameters;
/** @type {?} */
AutocompleteDisplayExample.prototype.myControl;
/** @type {?} */
AutocompleteDisplayExample.prototype.options;
/** @type {?} */
AutocompleteDisplayExample.prototype.filteredOptions;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
